import React, { useEffect, useState } from "react";
import { Form, Container } from "react-bootstrap";
import Select from "react-select";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import {
  faCamera,
  faUpload,
  faCloudUploadAlt,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GetAllBanks } from "../../features/wallet/slice";
import { SubmitModifyUPI } from "../../features/support/slice";
import Successfull_strip_modal from "../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";

const uploadFields = [
  { id: "old_upi_id_screenshot", label: "Old UPI ID Screenshot", mandatory: true, accept: "image/*" },
  { id: "new_upi_id_screenshot", label: "New UPI ID Screenshot", mandatory: true, accept: "image/*" },
  { id: "identity_card", label: "Identity Card", mandatory: true, accept: "*/*" },
  { id: "passbook_digital_banking", label: "Passbook / Digital Banking", mandatory: true, accept: "*/*" },
  {
    id: "video_holding",
    label:
      "Video holding : Identity Card, Passbook, OLD UPI ID and Piece of paper with today's date written on it",
    mandatory: true,
    isFile: true, accept: "video/*"
  },
  { id: "latest_deposit_receipt_1", label: "Latest Deposit Receipt 1", mandatory: true, accept: "*/*" },
  { id: "latest_deposit_receipt_2", label: "Latest Deposit Receipt 2", mandatory: false, accept: "*/*" },
];

const requiredFileIds = [
  "identity_card",
  "passbook_digital_banking",
  "old_upi_id_screenshot",
  "new_upi_id_screenshot",
  "latest_deposit_receipt_1",
  "video_holding",
];

function Modify_UPI() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const [files, setFiles] = useState({
    identity_card: null,
    old_upi_id_screenshot: null,
    new_upi_id_screenshot: null,
    passbook_digital_banking: null,
    latest_deposit_receipt_1: null,
    video_holding: null,
  });

  const [previews, setPreviews] = useState({
    identity_card: null,
    old_upi_id_screenshot: null,
    new_upi_id_screenshot: null,
    passbook_digital_banking: null,
    latest_deposit_receipt_1: null,
    video_holding: null,
  });

  const [fileErrors, setFileErrors] = useState({});

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      bank_id: null,
      new_upi_id: "",
    },
  });

  const allBanks = useSelector((state) => state.wallet.banks);

  useEffect(() => {
    dispatch(GetAllBanks({}));
  }, [dispatch]);

  const handleFileChange = (e, key) => {
    const file = e.target.files[0];
    if (!file) return;

    setFiles((prev) => ({
      ...prev,
      [key]: file,
    }));

    setPreviews((prev) => ({
      ...prev,
      [key]: file.type.startsWith("image") || file.type.startsWith("video")
        ? URL.createObjectURL(file)
        : "file_uploaded",
    }));

    setFileErrors((prev) => ({
      ...prev,
      [key]: null,
    }));
    e.target.value = "";

  };

  const validateFiles = () => {
    const newErrors = {};

    requiredFileIds.forEach((id) => {
      if (!files[id]) {
        const field = uploadFields.find((f) => f.id === id);
        newErrors[id] = `${field?.label} is required`;
      }
    });

    setFileErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onSubmit = async (data) => {
    try {
      if (!validateFiles()) return;

      const formData = new FormData();

      formData.append("bank_id", data.bank_id?.value);
      formData.append("bank_number", data.bank_id?.account_number);
      formData.append("new_upi_id", data.new_upi_id.trim());

      Object.entries(files).forEach(([key, file]) => {
        if (file) formData.append(key, file);
      });

      const res = await dispatch(SubmitModifyUPI(formData));

      if (res.meta?.requestStatus === "fulfilled") {
        setModalMessage(res?.payload?.data || "UPI Modification Submitted");
        setModalShow(true);
        reset();
        setFiles(
          Object.fromEntries(Object.keys(files).map((k) => [k, null]))
        );
        setPreviews(
          Object.fromEntries(Object.keys(previews).map((k) => [k, null]))
        );
        setFileErrors({});
        setTimeout(() => {
          setModalShow(false);
          navigate(-1);
        }, 2000);
      } else {
        setModalMessage(
          res?.payload?.errors || "Submission failed. Please try again"
        );
        setModalShow(true);
        setTimeout(() => setModalShow(false), 3000);
      }
    } catch (error) {
      console.error("Modify UPI Error:", error);
    }
  };

  return (
    <>
      <section className="Modify_Bank_Information">
        <Common_white_header headingText={"Modify UPI"} />
        <Container>
          <Form onSubmit={handleSubmit(onSubmit)} noValidate>

            <Form.Group className="form-group field_holder">
              <Form.Label>
                Select Bank <span className="mandatory_estrics">*</span>
              </Form.Label>
              <Controller
                name="bank_id"
                control={control}
                rules={{ required: "Bank is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={allBanks?.map((bank) => ({
                      value: bank?.id,
                      label: `${bank?.bank_name} - ${bank?.account_number}`,
                      account_number: bank?.account_number,
                    }))}
                    placeholder="Select Bank"
                  />
                )}
              />
              {errors.bank_id && (
                <small className="text-danger">{errors.bank_id.message}</small>
              )}
            </Form.Group>

            <Form.Group className="form-group field_holder">
              <Form.Label>
                New UPI ID <span className="mandatory_estrics">*</span>
              </Form.Label>

              <Form.Control
                type="text"
                placeholder="Please enter new UPI ID"
                {...register("new_upi_id", {
                  required: "UPI ID is required",
                  pattern: {
                    value: /^[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{2,64}$/,
                    message: "Enter a valid UPI ID (example: name@bank)",
                  },
                })}
              />

              {errors.new_upi_id && (
                <small className="text-danger">{errors.new_upi_id.message}</small>
              )}
            </Form.Group>

            {uploadFields.map((item) => (
              <Form.Group className="form-group field_holder" key={item.id}>
                <Form.Label>
                  {item.label}{" "}
                  {item.mandatory && (
                    <span className="mandatory_estrics">*</span>
                  )}
                </Form.Label>
                <div className="upload_box">
                  <input
                    type="file"
                    id={item.id}
                    hidden
                    accept={item.accept}
                    onChange={(e) => handleFileChange(e, item.id)}
                  />
                  <label htmlFor={item.id} className="photo_label">
                    {previews[item.id] && (
                      <div className="close-btn">
                        <FontAwesomeIcon
                          icon={faXmark}
                          onClick={(e) => {
                            // e.stopPropagation();
                            e.preventDefault();  // extra safety
                            setPreviews((prev) => ({
                              ...prev,
                              [item.id]: null,
                            }));
                          }}
                        />
                      </div>
                    )}
                    {previews[item.id] &&
                      previews[item.id] !== "file_uploaded" ? (

                      item?.accept?.includes("video") ? (
                        <video
                          src={previews[item.id]}
                          className="uploaded_img_preview"
                          controls
                        />
                      ) : (
                        <img
                          src={previews[item.id]}
                          alt="Preview"
                          className="uploaded_img_preview"
                        />
                      )

                    ) : previews[item.id] === "file_uploaded" ? (
                      <div className="success_upload">
                        <FontAwesomeIcon
                          icon={faCloudUploadAlt}
                          style={{ color: "#28a745" }}
                        />
                        <span>Uploaded</span>
                      </div>

                    ) : (
                      <>
                        <FontAwesomeIcon icon={item.isFile ? faUpload : faCamera} />
                        <span>{item.isFile ? "Upload" : "Photo"}</span>
                      </>
                    )}
                  </label>
                </div>
                {fileErrors[item.id] && (
                  <small className="text-danger">
                    {fileErrors[item.id]}
                  </small>
                )}
              </Form.Group>
            ))}

            <button
              type="submit"
              className="btn_register_bg"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Confirm"}
            </button>

          </Form>
        </Container>
      </section>

      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg={modalMessage}
      />
    </>
  );
}

export default Modify_UPI;